/**
 * Unified Offers JS — handles both one-time offers and subscription plans
 * in a single block. Uses data-mode attribute for CSS-driven state.
 * Survives Shopify theme editor re-renders.
 */
(function () {
  'use strict';

  function qs(root, sel) { return (root || document).querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function initUnifiedOffers() {
    var configEl = qs(document, 'script[data-uo-config]');
    if (!configEl) return;
    var cfg;
    try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }

    var root = qs(document, '[data-uo]');
    if (!root) return;
    /* Prevent double-bind on same DOM element */
    if (root.__uoBound) return;
    root.__uoBound = true;

    var sectionId = root.getAttribute('data-section-id');
    var toggle = qs(root, '[data-uo-toggle]');
    var subPanel = qs(root, '.uo__subscribe-panel');
    var otPanel = qs(root, '.uo__onetime-panel');
    var planCards = qsa(root, '[data-uo-plan]');
    var offerCards = qsa(root, '[data-uo-offer]');

    /* Find the product form */
    var sectionRoot = qs(document, '#MainProduct-' + sectionId) || qs(document, 'product-info');
    var form = sectionRoot
      ? (qs(sectionRoot, 'product-form form') || qs(sectionRoot, 'form[action*="/cart/add"]'))
      : qs(document, 'form[action*="/cart/add"]');
    var formIdInput = form ? qs(form, 'input[name="id"]') : null;

    /* Ensure selling_plan input exists */
    var spInput = form ? qs(form, 'input[name="selling_plan"][data-uo-sp]') : null;
    if (!spInput && form) {
      spInput = document.createElement('input');
      spInput.type = 'hidden';
      spInput.name = 'selling_plan';
      spInput.value = '';
      spInput.setAttribute('data-uo-sp', '');
      form.appendChild(spInput);
    }

    /* ─── Mode switching ─── */

    function setMode(mode) {
      root.setAttribute('data-mode', mode);
      if (mode === 'subscribe') {
        if (toggle) toggle.classList.add('is-active');
        applySelectedPlan();
      } else {
        if (toggle) toggle.classList.remove('is-active');
        if (spInput) { spInput.value = ''; spInput.disabled = true; }
        applySelectedOffer();
      }
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var amountNoDecimals = Math.floor(cents / 100).toString();
      var amountWithComma = amount.replace('.', ',');
      var fmt = cfg.moneyFormat || '${{amount}}';
      return fmt
        .replace('{{amount_with_comma_separator}}', amountWithComma)
        .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace('{{amount_no_decimals}}', amountNoDecimals)
        .replace('{{amount}}', amount);
    }

    function updateTogglePrice(variantId) {
      if (!toggle) return;
      var titleEl = qs(toggle, '.uo__toggle-title');
      if (!titleEl) return;
      /* Find the one-time offer whose variantId matches this plan's variant */
      var matchingOffer = (cfg.oneTimeOffers || []).find(function (o) { return o.variantId === variantId; });
      if (matchingOffer && matchingOffer.priceCents) {
        titleEl.textContent = 'One-time purchase • ' + formatMoney(matchingOffer.priceCents);
      } else {
        /* Fallback: show first offer price */
        var first = (cfg.oneTimeOffers || [])[0];
        if (first && first.priceCents) titleEl.textContent = 'One-time purchase • ' + formatMoney(first.priceCents);
      }
    }

    function applySelectedPlan() {
      var selected = qs(root, '[data-uo-plan].is-selected');
      if (!selected) {
        /* Default to first plan */
        var first = planCards[0];
        if (first) { first.classList.add('is-selected'); var r = qs(first, 'input[type="radio"]'); if (r) r.checked = true; selected = first; }
      }
      if (!selected) return;
      var planKey = selected.getAttribute('data-uo-plan');
      var plan = findPlan(planKey);
      if (!plan) return;
      if (spInput) { spInput.disabled = false; spInput.value = plan.sellingPlanId || ''; }
      if (formIdInput && plan.variantId) {
        formIdInput.value = plan.variantId;
        formIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateTogglePrice(plan.variantId);
    }

    function applySelectedOffer() {
      var selected = qs(root, '[data-uo-offer].is-selected');
      if (!selected) {
        var first = offerCards[0];
        if (first) { first.classList.add('is-selected'); var r = qs(first, 'input[type="radio"]'); if (r) r.checked = true; selected = first; }
      }
      if (!selected) return;
      var offerKey = selected.getAttribute('data-uo-offer');
      var offer = findOffer(offerKey);
      if (!offer) return;
      if (formIdInput && offer.variantId) {
        formIdInput.value = offer.variantId;
        formIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function findPlan(key) {
      return (cfg.subscriptionPlans || []).find(function (p) { return p.plan === key; }) || null;
    }

    function findOffer(key) {
      return (cfg.oneTimeOffers || []).find(function (o) { return o.offer === key; }) || null;
    }

    /* ─── Toggle click (one-time purchase link) ─── */

    if (toggle) {
      toggle.addEventListener('click', function () {
        setMode('onetime');
      });
    }

    /* ─── Back to subscribe link ─── */
    var backBtn = qs(root, '[data-uo-back-sub]');
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        setMode('subscribe');
      });
    }

    /* ─── Plan card clicks ─── */

    planCards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        /* Don't interfere with monthly gifts accordion */
        if (e.target.closest('.uo__monthly-gifts')) return;
        planCards.forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        var radio = qs(card, 'input[type="radio"]');
        if (radio) radio.checked = true;
        /* Switch to subscribe mode if not already */
        if (root.getAttribute('data-mode') !== 'subscribe') {
          setMode('subscribe');
        } else {
          applySelectedPlan();
        }
      });
    });

    /* ─── Offer card clicks ─── */

    offerCards.forEach(function (card) {
      card.addEventListener('click', function () {
        offerCards.forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        var radio = qs(card, 'input[type="radio"]');
        if (radio) radio.checked = true;
        /* Switch to one-time mode if not already */
        if (root.getAttribute('data-mode') !== 'onetime') {
          setMode('onetime');
        } else {
          applySelectedOffer();
        }
      });
    });

    /* ─── Gift injection on ATC ─── */

    if (form && !form.__uoAtcBound) {
      form.__uoAtcBound = true;
      var productFormEl = qs(document, 'product-form');

      form.addEventListener('submit', function (e) {
        var mode = root.getAttribute('data-mode');
        var gifts = [];

        if (mode === 'onetime') {
          var selOffer = qs(root, '[data-uo-offer].is-selected');
          if (selOffer) {
            var offerKey = selOffer.getAttribute('data-uo-offer');
            var offer = findOffer(offerKey);
            if (offer && offer.gifts) gifts = offer.gifts;
          }
        } else if (mode === 'subscribe') {
          var selPlan = qs(root, '[data-uo-plan].is-selected');
          if (selPlan) {
            var planKey = selPlan.getAttribute('data-uo-plan');
            var plan = findPlan(planKey);
            if (plan && plan.gifts) gifts = plan.gifts;
          }
        }

        if (gifts.length === 0) return; /* No gifts → let Dawn handle it normally */

        e.preventDefault();
        e.stopImmediatePropagation();

        var btn = productFormEl ? productFormEl.submitButton : null;
        var spinner = productFormEl ? productFormEl.querySelector('.loading__spinner') : null;
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
        if (spinner) spinner.classList.remove('hidden');

        /* Build items: main product (with selling_plan if subscribe) + gifts (no selling_plan) */
        var mainItem = { id: Number(formIdInput.value), quantity: 1 };
        if (mode === 'subscribe' && spInput && spInput.value) {
          mainItem.selling_plan = Number(spInput.value);
        }
        var items = [mainItem];
        gifts.forEach(function (gift) {
          if (gift.variantId) {
            items.push({
              id: Number(gift.variantId),
              quantity: 1,
              properties: { _gift: 'true', _parent_variant: String(formIdInput.value) }
            });
          }
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            var cartDrawer = qs(document, 'cart-drawer') || qs(document, 'cart-notification');
            if (cartDrawer) {
              cartDrawer.classList.remove('is-empty');
              fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
                .then(function (r) { return r.json(); })
                .then(function (sections) {
                  if (cartDrawer.renderContents) cartDrawer.renderContents({ sections: sections });
                })
                .catch(function () { window.location.href = '/cart'; });
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function (err) { console.error('[uo] ATC failed', err); })
          .finally(function () {
            if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
            if (spinner) spinner.classList.add('hidden');
          });
      }, true /* CAPTURE phase */);
    }

    /* ─── Initialize ─── */

    var initialMode = root.getAttribute('data-mode') || 'subscribe';
    setMode(initialMode);

    /* Hide native selling plan widgets */
    qsa(document, 'selling-plan-widget, selling-plan-selector, .shopify-selling-plan').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  /* ─── Boot ─── */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUnifiedOffers);
  } else {
    initUnifiedOffers();
  }

  /* Shopify editor re-render handlers */
  document.addEventListener('shopify:section:load', function () { initUnifiedOffers(); });
  document.addEventListener('shopify:block:select', function () { setTimeout(initUnifiedOffers, 50); });
  document.addEventListener('shopify:block:deselect', function () { setTimeout(initUnifiedOffers, 50); });
})();
